export const baseUrl = `clients/admin/liquid-snippets`;
